// extracted by mini-css-extract-plugin
export default {"copyButton":"ValidationRules_copyButton__ZqICX"};